<script setup lang="ts">
defineProps<{ title: string }>();
</script>

<template>
  <div class="space-y-8">
    <h2 class="h1 text-orange">
      {{ title }}
    </h2>
    <div class="">
      <slot />
    </div>
  </div>
</template>
